import React from 'react';
import ReactECharts from 'echarts-for-react';

const AssessmentTrendChart = ({ history }) => {
  const sortedHistory = [...history].sort((a, b) => new Date(a.completedDate) - new Date(b.completedDate));
  
  const option = {
    tooltip: {
      trigger: 'axis',
      backgroundColor: '#1e293b',
      padding: [12, 16],
      textStyle: { color: '#fff' },
      borderWidth: 0,
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: sortedHistory.map(h => h.completedDate),
      axisLine: { lineStyle: { color: '#e2e8f0' } },
      axisLabel: { color: '#64748b', fontSize: 11, rotate: 30 }
    },
    yAxis: {
      type: 'value',
      min: 0,
      max: 100,
      axisLine: { show: false },
      splitLine: { lineStyle: { color: '#f1f5f9' } },
      axisLabel: { color: '#64748b' }
    },
    series: [
      {
        name: 'Overall Score',
        type: 'line',
        smooth: true,
        data: sortedHistory.map(h => h.overallScore),
        symbol: 'circle',
        symbolSize: 8,
        itemStyle: { color: '#3b82f6' },
        lineStyle: { width: 3, color: '#3b82f6' },
        areaStyle: {
          color: {
            type: 'linear',
            x: 0, y: 0, x2: 0, y2: 1,
            colorStops: [
              { offset: 0, color: 'rgba(59, 130, 246, 0.2)' },
              { offset: 1, color: 'rgba(59, 130, 246, 0)' }
            ]
          }
        }
      }
    ]
  };

  return <ReactECharts option={option} style={{ height: '300px', width: '100%' }} />;
};

export default AssessmentTrendChart;